(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zf-market-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zf-market-selector')) {
  customElements.define('zf-market-selector', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const form = this.querySelector('form');
      const select = this.querySelector('select');
      const custom = this.querySelector('.zf-market-custom');
      const trigger = this.querySelector('.zf-market-trigger');
      const list = this.querySelector('.zf-market-options');
      if (!form || !select || !custom || !trigger || !list) return;
      const items = Array.from(list.querySelectorAll('[data-country-code]'));
      const close = (restoreFocus = false) => {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      const open = () => {
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        (items.find(item => item.dataset.countryCode === select.value) || items[0])?.focus();
      };
      trigger.addEventListener('click', () => list.hidden ? open() : close(), { signal });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault(); open();
        }
      }, { signal });
      list.addEventListener('keydown', event => {
        const index = items.indexOf(document.activeElement);
        if (event.key === 'Escape') { event.preventDefault(); close(true); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          items[(index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length]?.focus();
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); (event.key === 'Home' ? items[0] : items[items.length - 1])?.focus();
        }
        if (event.key === 'Tab') close();
      }, { signal });
      items.forEach(item => item.addEventListener('click', () => {
        const country = item.dataset.countryCode;
        if (country === select.value) { close(true); return; }
        select.value = country;
        close();
        form.requestSubmit();
      }, { signal }));
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, { signal });
      select.addEventListener('change', () => form.requestSubmit(), { signal });
      custom.hidden = false;
      select.hidden = true;
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
